export enum SurveyStepperSteps {
  Intro = 'Intro',
  Survey = 'Survey',
  WrapUp = 'WrapUp'
}

export type SurveyStepperStep = {
  key: SurveyStepperSteps;
  name: string;
  selected: boolean;
  link?: string;
};
